export enum Widgets {
  LOL_CHAMPION_BUILD = 'lol-champion-build',
  LOL_CHAMPION_BUILD_COMPACT = 'lol-champion-build-compact',
}

export enum Tooltips {
  LOL_CHAMPION_TOOLTIP = 'lol-champion-tooltip',
}
